import { Controller } from 'stimulus'

export default class extends Controller {
  static get targets() { return  ['checkbox'] }

  toggle (e) {
    e.preventDefault()

    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = e.target.checked
    })
  }
}



// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/checkbox_select_all_controller.js